import { useEffect } from "react";

const SITE_ORIGIN = "https://mdcustomconstruction.com";

interface PageMeta {
  title: string;
  description?: string;
  canonical?: string;
  ogType?: "website" | "article";
  ogImage?: string;
}

const setMetaByName = (name: string, content: string) => {
  let el = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setMetaByProperty = (property: string, content: string) => {
  let el = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setLink = (rel: string, href: string) => {
  let el = document.querySelector(`link[rel="${rel}"]`) as HTMLLinkElement | null;
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export const usePageMeta = ({ title, description, canonical, ogType = "website", ogImage }: PageMeta) => {
  useEffect(() => {
    document.title = title;

    const url =
      canonical ||
      (typeof window !== "undefined"
        ? `${SITE_ORIGIN}${window.location.pathname}${window.location.search}`
        : SITE_ORIGIN);

    if (description) {
      setMetaByName("description", description);
      setMetaByProperty("og:description", description);
      setMetaByName("twitter:description", description);
    }

    setMetaByProperty("og:title", title);
    setMetaByName("twitter:title", title);
    setMetaByProperty("og:type", ogType);
    setMetaByProperty("og:url", url);
    setLink("canonical", url);

    if (ogImage) {
      const absoluteImage = ogImage.startsWith("http") ? ogImage : `${SITE_ORIGIN}${ogImage}`;
      setMetaByProperty("og:image", absoluteImage);
      setMetaByName("twitter:image", absoluteImage);
    }
  }, [title, description, canonical, ogType, ogImage]);
};